import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReportService } from '../../services/report.service';

@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html',
  styleUrls: ['./generate-report.component.scss']
})
export class GenerateReportComponent implements OnInit {

  saving: boolean = false;

  reportForm: FormGroup;

  reportValues: any;

  constructor(private formBuilder: FormBuilder, private reportService: ReportService) { }

  ngOnInit(): void {

    this.reportForm = this.formBuilder.group({
      date: ['', Validators.required]
    })

    this.reportForm.get("date").setValue(new Date());
    if (!!this.reportForm.get("date").value) {
      var date = new Date(this.reportForm.get("date").value);
      const yy = new Date(date).getFullYear();
      const mm = new Date(date).getMonth() + 1;
      const dd = new Date(date).getDate();

      var interMedDt = `${dd}-${mm}-${yy}`
      this.reportService.getDailyReportValues(interMedDt).subscribe(x => {
        this.reportValues = x;
        console.log(x);
      });
    }


    this.reportForm.get("date").valueChanges.subscribe(x => {
      if (!!this.reportForm.get("date").value) {
        var date = new Date(this.reportForm.get("date").value);
        const yy = new Date(date).getFullYear();
        const mm = new Date(date).getMonth() + 1;
        const dd = new Date(date).getDate();

        var interMedDt = `${dd}-${mm}-${yy}`
        this.reportService.getDailyReportValues(interMedDt).subscribe(x => {
          this.reportValues = x;
          console.log(x);
        });
      }
    });
  }

}